import { downgradeComponent } from "@angular/upgrade/static";
import { UIGmapMarkerComponent } from "@directives/_map/angularGoogleMaps/uiGmapMarker.component";
import { UIGmapMarkersComponent } from "@directives/_map/angularGoogleMaps/uiGmapMarkers.component";
import { UIGmapPolygonComponent } from "@directives/_map/angularGoogleMaps/uiGmapPolygon.component";
import { UIGmapPolylineComponent } from "@directives/_map/angularGoogleMaps/uiGmapPolyline.component";
import { UIGmapPolylinesComponent } from "@directives/_map/angularGoogleMaps/uiGmapPolylines.component";
import { GeoAreasComponent } from "@directives/_map/geofences/geoarea.directive";
import { VeriMapHeatMapComponent } from "@directives/_map/veriMap/veriMapHeatMap/veriMapHeatMap.component";
import { VeriMapJourneyComponent } from "@directives/_map/veriMap/veriMapJourneys/veriMapJourneys.component";
import { VeriMapLocationComponent } from "@directives/_map/veriMap/veriMapLocation/veriMapLocation.component";
import { VeriMapVideoEventComponent } from "@directives/_map/veriMap/veriMapVideoEvent/veriMapVideoEvent.component";
import * as angular from "angular";
import { GeofenceNavPointsComponent } from "./geofences/geofenceNavPoints/geofenceNavPoints.component";
import { GeofencesComponent } from "./geofences/geofences.directive";
import { GeofenceShapeComponent } from "./geofences/geofenceShape/geofenceShape.component";
import { VeriMapControlsComponent } from "./mapControls/mapControls.directive";
import { VMapComponent } from "./v-map/v-map/v-map.component";
import { VeriMapComponent } from "./veriMap/veriMapComponent/veriMap.component";
import { VeriMapContainerComponent } from "./veriMap/veriMapContainer/veriMapContainer.component";
import { VeriMapCurrentJourneyComponent } from "./veriMap/veriMapCurrentJourney/veriMapCurrentJourney.component";
import { VeriMapJourneysNewComponent } from "./veriMap/veriMapJourneysNew/veriMapJourneysNew.component";
import { VeriMapPlotComponent } from "./veriMap/veriMapPlot/veriMapPlot.component";
import { VeriMapPlotHistoryComponent } from "./veriMap/veriMapPlotHistory/veriMapPlotHistory.component";
import { VeriMapPopupComponent } from "./veriMap/veriMapPopup/veriMapPopup.component";
import { VeriMapRouteComponent } from "./veriMap/veriMapRoute/veriMapRoute.component";
import { VeriMapRouteOldComponent } from "./veriMap/veriMapRouteOld/veriMapRoute.old";
import { VeriMapSingleGeofenceComponent } from "./veriMap/veriMapSingleGeofence/veriMapSingleGeofence.component";
import { VeriMapTMSAuditComponent } from "./veriMap/veriMapTMSAudit/veriMapTMSAudit.component";
import { VeriMapVehiclesComponent } from "./veriMap/veriMapVehicles/veriMapVehicles.component";

angular
    .module("app.map.directives", ["ngDebounceThrottle"/*"app.components.livemap"*/])

    .component("veriMapContainer", new VeriMapContainerComponent())
    .component("veriMap", new VeriMapComponent())
    .directive("veriMapCurrentJourney", downgradeComponent({ component: VeriMapCurrentJourneyComponent }))
    .component("veriMapHeatMap", new VeriMapHeatMapComponent())
    .component("veriMapJourneys", new VeriMapJourneyComponent())
    .component("veriMapPlot", new VeriMapPlotComponent())
    .component("veriMapLocation", new VeriMapLocationComponent())
    .component("veriMapPlotHistory", new VeriMapPlotHistoryComponent())
    .component("veriMapPopup", new VeriMapPopupComponent())
    .component("veriMapRoute", new VeriMapRouteComponent())
    .component("veriMapRouteOld", new VeriMapRouteOldComponent())
    .component("veriMapVehicles", new VeriMapVehiclesComponent())
    .component("veriMapVideoEvent", new VeriMapVideoEventComponent())
    .component("veriMapControls", new VeriMapControlsComponent())
    .component("veriMapTmsAudit", new VeriMapTMSAuditComponent())
    .component("veriMapSingleGeofence", new VeriMapSingleGeofenceComponent())
    .component("geofences", new GeofencesComponent())
    .component("geoAreas", new GeoAreasComponent())
    .component("geofenceNavPoints", new GeofenceNavPointsComponent())
    .component("geofenceShape", new GeofenceShapeComponent())

    //.directive("ngxDc", downgradeComponent({ component: NgxDynamicCompilerComponent }))

    .directive("uiGmapMarker", downgradeComponent({ component: UIGmapMarkerComponent }))
    .directive("uiGmapMarkers", downgradeComponent({ component: UIGmapMarkersComponent }))
    .directive("uiGmapPolyline", downgradeComponent({ component: UIGmapPolylineComponent }))
    .directive("uiGmapPolylines", downgradeComponent({ component: UIGmapPolylinesComponent }))
    .directive("uiGmapPolygon", downgradeComponent({ component: UIGmapPolygonComponent }))

    .directive("veriMapJourneysNew", downgradeComponent({ component: VeriMapJourneysNewComponent }))


    .directive("vMap", downgradeComponent({ component: VMapComponent }))
    ;
